import React from 'react';
import {
  CourseSessionContentStateEnum,
  CourseSessionStateEnum,
} from 'src/api/ProactApiClient';
import {
  CancelledIcon,
  ErrorIcon,
  PendingIcon,
  SuccessIcon,
  WarningIcon,
} from 'src/design/atoms/icons/StatusIcons';

export interface SessionStatusIconProps {
  state: CourseSessionStateEnum;
}
export const SessionStatusIcon: React.FC<SessionStatusIconProps> = ({
  state,
}) => {
  switch (state) {
    case CourseSessionStateEnum.Completed:
      return <SuccessIcon />;

    case CourseSessionStateEnum.Pending:
    case CourseSessionStateEnum.NotStarted:
      return <PendingIcon />;

    case CourseSessionStateEnum.Cancelled:
      return <WarningIcon />;

    case CourseSessionStateEnum.Invalid:
    case CourseSessionStateEnum.Failed:
    case CourseSessionStateEnum.Expired:
    default:
      return <ErrorIcon />;
  }
};

export interface SessionContentStatusIconProps {
  state: CourseSessionContentStateEnum;
}
export const SessionContentStatusIcon: React.FC<
  SessionContentStatusIconProps
> = ({state}) => {
  switch (state) {
    case CourseSessionContentStateEnum.Completed:
      return <SuccessIcon />;

    case CourseSessionContentStateEnum.Pending:
    case CourseSessionContentStateEnum.NotStarted:
      return <PendingIcon />;

    case CourseSessionContentStateEnum.Cancelled:
      return <CancelledIcon />;

    case CourseSessionContentStateEnum.Invalid:
    case CourseSessionContentStateEnum.Failed:
    default:
      return <ErrorIcon />;
  }
};

export interface QuestionAnswerResultIconProps {
  isCorrect?: boolean;
}
export const QuestionAnswerResultIcon: React.FC<
  QuestionAnswerResultIconProps
> = ({isCorrect}) => {
  switch (isCorrect) {
    case true:
      return <SuccessIcon />;
    default:
      return <ErrorIcon />;
  }
};
